document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form.newsletter-form').forEach(form => {
    const email = form.querySelector('input[type="email"]');
    const button = form.querySelector('button[type="submit"]');
    if (!email || !button) return;

    let status = form.querySelector('.newsletter-submit-status');
    if (!status) {
      status = document.createElement('p');
      status.className = 'newsletter-submit-status';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
    }

    const originalLabel = button.textContent;
    const isPasswordPage = form.classList.contains('password-form');
    let timer = null;
    let submitting = false;

    const begin = () => {
      if (!email.checkValidity() || submitting) return;
      submitting = true;
      clearTimeout(timer);
      status.classList.remove('is-error');
      status.classList.add('is-loading');
      status.textContent = isPasswordPage
        ? 'Secure verification in progress — this may take a few seconds.'
        : 'Securely submitting your email…';
      button.textContent = 'SUBMITTING…';
      button.setAttribute('aria-busy', 'true');

      timer = window.setTimeout(() => {
        if (!document.documentElement.contains(form)) return;
        submitting = false;
        status.classList.remove('is-loading');
        status.classList.add('is-error');
        status.textContent = 'We could not complete the secure verification. Please allow hCaptcha or pause content blocking, then try again.';
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
      }, 15000);
    };

    button.addEventListener('click', begin);
    form.addEventListener('submit', begin);
  });

  if (!window.matchMedia('(max-width: 650px)').matches) return;

  const form = document.querySelector('.main-product-premium form[data-product-form]');
  if (!form) return;

  const sourceSelects = Array.from(form.querySelectorAll('select[data-option-select]'));
  const sourceButton = form.querySelector('[data-main-atc]');
  if (!sourceSelects.length || !sourceButton) return;

  const assistant = document.createElement('aside');
  assistant.className = 'valoris-mobile-cart-assistant';
  assistant.setAttribute('aria-label', 'Quick product purchase');
  assistant.innerHTML = '<div class="valoris-mobile-cart-assistant__heading"><span>Purchase assistant</span><span>Choose options & add</span></div><div class="valoris-mobile-cart-assistant__controls"></div>';

  const controls = assistant.querySelector('.valoris-mobile-cart-assistant__controls');
  const assistantSelects = sourceSelects.map((source, index) => {
    const field = document.createElement('div');
    field.className = 'valoris-mobile-cart-assistant__field';

    const label = document.createElement('label');
    const labelText = source.name.match(/\[([^\]]+)\]/);
    label.textContent = labelText ? labelText[1] : 'Option ' + (index + 1);

    const select = document.createElement('select');
    select.setAttribute('aria-label', label.textContent);
    Array.from(source.options).forEach(option => {
      select.add(new Option(option.text, option.value, option.defaultSelected, option.selected));
    });

    select.addEventListener('change', () => {
      source.value = select.value;
      source.dispatchEvent(new Event('input', { bubbles: true }));
      source.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(sync, 0);
    });

    field.append(label, select);
    controls.appendChild(field);
    return select;
  });

  const add = document.createElement('button');
  add.type = 'button';
  add.className = 'valoris-mobile-cart-assistant__add';
  add.textContent = 'Add to cart';
  add.addEventListener('click', () => {
    if (!sourceButton.disabled) sourceButton.click();
  });
  controls.appendChild(add);

  const sync = () => {
    sourceSelects.forEach((source, index) => {
      const target = assistantSelects[index];
      Array.from(target.options).forEach(option => {
        const sourceOption = Array.from(source.options).find(item => item.value === option.value);
        option.disabled = sourceOption ? sourceOption.disabled : false;
      });
      target.value = source.value;
    });

    add.disabled = sourceButton.disabled;
    add.textContent = sourceButton.textContent.trim() || 'Add to cart';
  };

  form.addEventListener('change', () => window.setTimeout(sync, 0));
  form.addEventListener('click', event => {
    if (event.target.closest('[data-option-chip]')) window.setTimeout(sync, 0);
  });

  new MutationObserver(sync).observe(sourceButton, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true
  });

  document.body.appendChild(assistant);
  document.body.classList.add('valoris-has-mobile-cart-assistant');
  sync();
});
